import { splitIntoEqualParts } from './splitIntoEqualParts';

export const splitDifference = (prev: number, next: number, quantity: number): number[] => {
  const diff = prev - next;

  return splitIntoEqualParts(diff, quantity).map(value => value * Math.sign(diff));
};
